import { render, staticRenderFns } from "./userterminal.vue?vue&type=template&id=03857f3d&"
import script from "./userterminal.vue?vue&type=script&lang=js&"
export * from "./userterminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports